import { useNavigate, useLocation } from 'react-router-dom';
import { Bot, Settings, BarChart2, Calendar, CheckCircle2 } from 'lucide-react';
import { useStore } from '@/store/useStore';
import { t } from '@/i18n/translations';

export default function AppHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const { settings, progress, templates } = useStore();
  const lang = settings.language;

  const selectedTemplates = templates.filter((t) => (progress.selectedTemplates || []).includes(t.id));
  const isTrackerPage = location.pathname === '/tracker';

  return (
    <header className="flex items-center justify-between px-4 py-3 bg-white/80 backdrop-blur-sm sticky top-0 z-10">
      <div className="flex items-center gap-2">
        <CheckCircle2 className="w-6 h-6 text-primary-500" />
        <span className="font-semibold">
          <span className="text-primary-500">Easy</span>
          <span className="text-gray-800">Habits</span>
        </span>
      </div>
      <div className="flex items-center gap-1">
        <button
          onClick={() => navigate('/coach')}
          className={`p-2 rounded-lg transition-colors ${
            location.pathname === '/coach'
              ? 'text-primary-600 bg-primary-50'
              : 'text-gray-600 hover:text-primary-600 hover:bg-primary-50'
          }`}
          title={t('tracker.coach', lang)}
        >
          <Bot className="w-5 h-5" />
        </button>
        <button
          onClick={() => navigate('/tracker')}
          className={`p-2 rounded-lg transition-colors ${
            isTrackerPage
              ? 'text-primary-600 bg-primary-50'
              : 'text-gray-600 hover:text-primary-600 hover:bg-primary-50'
          }`}
          title={t('tracker.today', lang)}
        >
          <Calendar className="w-5 h-5" />
        </button>
        <button
          onClick={() => navigate('/stats')}
          className={`p-2 rounded-lg transition-colors ${
            location.pathname === '/stats'
              ? 'text-primary-600 bg-primary-50'
              : 'text-gray-600 hover:text-primary-600 hover:bg-primary-50'
          }`}
          title={t('tracker.stats', lang)}
        >
          <BarChart2 className="w-5 h-5" />
        </button>
        <button
          onClick={() => navigate('/settings')}
          className={`p-2 rounded-lg transition-colors ${
            location.pathname === '/settings'
              ? 'text-primary-600 bg-primary-50'
              : 'text-gray-600 hover:text-primary-600 hover:bg-primary-50'
          }`}
          title={t('settings.title', lang)}
        >
          <Settings className="w-5 h-5" />
        </button>
      </div>
    </header>
  );
}
